import { render } from "./corruptionReport.vue?vue&type=template&id=ccc4ec50&scoped=true"
import script from "./corruptionReport.vue?vue&type=script&lang=js"
export * from "./corruptionReport.vue?vue&type=script&lang=js"

import "./corruptionReport.vue?vue&type=style&index=0&id=ccc4ec50&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccc4ec50"]])

export default __exports__